<template>
    <div>
        <!-- Pay all sum now -->
        <custom-checkbox
            v-if="order.offer.is_pay_all_sum_now"
            :value="paymentType === paymentTypes.is_pay_all_sum_now"
            @click.native.stop="changeType(paymentTypes.is_pay_all_sum_now)"
            :noShadow="true"
            :style-modifier="['custom-checkbox__lesson']"
            class="items-center mb-20 mt-20 partial-checkbox"
            :labelText="getText('pay_all_sum_now_option_titles') || t('payments.instant_payment')"
        />
        <!-- Pay by installments -->
        <custom-checkbox
            v-if="order.offer.is_pay_by_equal_parts"
            :value="paymentType === paymentTypes.is_pay_by_equal_parts"
            @click.native.stop="changeType(paymentTypes.is_pay_by_equal_parts)"
            :noShadow="true"
            :style-modifier="['custom-checkbox__lesson']"
            class="items-center mb-20 partial-checkbox"
            :labelText="getText('pay_by_equal_parts_option_titles') || t('payments.partial_payment')"
        />
        <!-- Payment parts list -->
        <transition name="fade">
            <public-offer-partial-schedule
                v-if="paymentType === paymentTypes.is_pay_by_equal_parts"
                :loading="loading"
                :paymentParts="paymentParts"
            />
        </transition>
        <!-- Pay by specified schedule -->
        <custom-checkbox
            v-if="order.offer.is_pay_by_specified_schedule"
            :value="paymentType === paymentTypes.is_pay_by_specified_schedule"
            @click.native.stop="changeType(paymentTypes.is_pay_by_specified_schedule)"
            :noShadow="true"
            :style-modifier="['custom-checkbox__lesson']"
            class="items-center mb-20 mt-20 partial-checkbox"
            :labelText="
                getText('specified_schedule_payments_type_option_titles') || t('payments.specified_schedule_payment')
            "
        />
        <!-- Payment parts list -->
        <transition name="fade">
            <public-offer-partial-schedule
                v-if="paymentType === paymentTypes.is_pay_by_specified_schedule"
                :loading="loading"
                :paymentParts="paymentParts"
            />
        </transition>
        <!-- Pay by parts from bank -->
        <custom-checkbox
            v-if="order.offer.is_bank_credit_allowed"
            :value="paymentType === paymentTypes.is_bank_credit_allowed"
            @click.native.stop="changeType(paymentTypes.is_bank_credit_allowed)"
            :noShadow="true"
            :style-modifier="['custom-checkbox__lesson']"
            class="items-center mb-20 mt-20 partial-checkbox"
            :labelText="getText('bank_credit_allowed_option_titles') || t('payments.pay_partial_payments_from_bank')"
        />
    </div>
</template>

<script>
import CustomCheckbox from "@components/Forms/CustomCheckbox"
import PublicOfferPartialSchedule from "./PublicOfferPartialSchedule"

export default {
    name: "PublicOfferPaymentTypes",
    components: {
        PublicOfferPartialSchedule,
        CustomCheckbox
    },
    inject: ["getPaymentTypes"],
    props: {
        order: {
            type: Object,
            required: true
        },
        paymentType: {
            type: String,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        paymentParts: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        paymentTypes: null
    }),
    created() {
        this.paymentTypes = this.getPaymentTypes()
    },
    methods: {
        getText(key) {
            if (this.order?.offer?.[key]) {
              let found = this.order.offer[key].find(t => t.code === window.app_current_locale);
              if (found) {
                return found.title;
              }
              found = this.order.offer[key].find(t => t.code === 'en');
              if (found) {
                return found.title;
              }
            }
            return ""
        },
        changeType(val) {
            if (val === this.paymentType) return
            this.$emit("change:paymentType", val)
        }
    }
}
</script>

<style scoped>

</style>
